export const WAY = {
    BASE_PATH: '/distribution-region/way-management/',
    GET_ALL: '/way-management',
    GET_ONE: '/way-management/edit/',
    CREATE: '/way-management/create',
    UPDATE: '/way-management/update/',
    DELETE: '/way-management/delete/',
    ADD_NEW_TITLE: 'Add New Way',
};
